<template>
  <editSubmission v-if="editStatus" :editStatus="editStatus" :submissionInfo="this.selectedSubmission" @close="close()"></editSubmission>
  <v-card width="100%" height="100%" v-else outlined>
    <v-toolbar color="secondary" dark class="title" flat>
      <v-icon left>fas fa-list</v-icon>
      {{ viewStatus ? `Viewing: ${selectedSubmission.title}` : "Submitted Requests"}}
    </v-toolbar>
    <viewSubmission v-if="viewStatus" :submissionInfo="selectedSubmission" @close="close()" @edit="editSubmission(selectedSubmission)"></viewSubmission>
    <v-card-text v-else>
      <v-row no-gutters>
        <v-col cols="12" md="4" class="text-center">
          <v-text-field
            label="Search"
            v-model="searchString"
            color="secondary"
            clearable
            @click:clear="searchString = ''"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="4" offset-md="4" class="text-center">
          <v-select
            label="Filter By Category"
            :items="getStatusOptions"
            v-model="categoryFilter"
            item-color="secondary"
            color="secondary"
            clearable
            @click:clear="categoryFilter = null"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row align="center" class="text-center text-md-left" v-if="$vuetify.breakpoint.mdAndUp">
        <v-col md="3" offset-md="6" class="text-left">Event Date:</v-col>
        <v-col md="1">View</v-col>
        <v-col md="1">Edit</v-col>
        <v-col md="1">Delete</v-col>
      </v-row>
      <v-row align="center" class="subtitle-1 submissions text-center text-md-left pa-1" v-for="item in getFilteredSubmissions" no-gutters :key="item.id">
        <!-- <v-col cols="1">
          <v-icon v-if="item.status == 'Approved'" color="secondary">far fa-check-circle</v-icon>
          <v-icon v-if="item.status == 'Pending'" color="red">far fa-pause-circle</v-icon>
          <v-icon v-if="item.status == 'Complete'" color="secondary">fas fa-stop-circle</v-icon>
          <v-icon v-if="item.status == 'Submitted'" color="accent">far fa-arrow-alt-circle-right</v-icon>
        </v-col> -->
        <v-col cols="12" md="6">
          {{ item.title }}
        </v-col>
        <v-col cols="12" md="3" class="text-md-left">
          {{ item.startDate }}
        </v-col>
        <v-col cols="4" md="1" class="text-center">
          <v-btn icon outlined small color="secondary" @click="viewSubmission(item)">
            <v-icon small>fas fa-list</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="4" md="1" class="text-center">
          <v-btn icon outlined small color="secondary" @click="editSubmission(item)">
            <v-icon small>fas fa-edit</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="4" md="1" class="text-center">
          <v-btn icon outlined small color="red" @click="confirmDelete(item)">
            <v-icon small>fas fa-trash</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- CONFIRM DELETION DIALOG -->
    <v-dialog
      v-model="confirmDeleteDialog"
      width="500px"
    >
      <v-card>
        <v-toolbar color="secondary" dense dark>
          <v-toolbar-title>Confirm Delete:</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row align="center" justify="center" class="text-center subtitle-1">
            <v-col cols="12">
              Are you sure you want to delete <b>{{ selectedSubmission.title}}</b>?
            </v-col>
            <v-col cols="6">
              <v-btn @click="close()" outlined color="red">
                <v-icon left small>fas fa-times</v-icon>
                Cancel
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn @click="deleteSubmission()" outlined>
                <v-icon left small>fas fa-check</v-icon>
                Yes
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import editSubmission from '@/components/new'
import viewSubmission from '@/components/adminComponents/viewSubmission'
export default {
  components: {
    editSubmission,
    viewSubmission
  },
  data(){
    return {
      categoryFilter        : null,
      confirmDeleteDialog   : false,
      editStatus            : false,
      searchStatus          : "",
      searchString          : "",
      selectedSubmission    : {},
      viewStatus            : false
    }
  },
  methods: {
    close(){
      this.categoryFilter     = null
      this.confirmDeleteDialog= false
      this.editStatus         = false
      this.searchStatus       = ""
      this.selectedSubmission = {}
      this.searchString       = ""
      this.viewStatus         = false
    },
    confirmDelete(submission){
      this.selectedSubmission   = submission
      this.confirmDeleteDialog  = true
    },
    deleteSubmission(){
      this.$store.dispatch('deleteSubmission', this.selectedSubmission)
      this.confirmDeleteDialog  = false
    },
    editSubmission(submission){
      this.selectedSubmission = submission
      this.editStatus         = true
    },
    filterByString(list){
      return list.filter(item => item.title.toLowerCase().includes(this.searchString.toLowerCase()))
    },
    filterByStatus(list){
      return list.filter(item => item.status == this.searchStatus)
    },
    viewSubmission(submission){
      this.viewStatus         = true
      this.selectedSubmission = submission
    }
  },
  computed: {
    getFilteredSubmissions(){
      let sortSubmissions = function(allSubs){
        return allSubs.sort((a, b) => {
          if (a.startDate > b.startDate) {
            return -1
          }
          else {
            return 1
          }
        })
      }
      if (!this.searchString && !this.categoryFilter){
        return  sortSubmissions(this.getSubmissions)
      }
      if (!this.searchString && this.categoryFilter){
        return sortSubmissions(this.getSubmissions.filter(sub => sub.status == this.categoryFilter))
      }
      if (this.searchString && !this.categoryFilter){
        return sortSubmissions(this.getSubmissions.filter(sub => sub.title.toLowerCase().includes(this.searchString.toLowerCase())))
      }
      if (this.searchString && this.categoryFilter){
        return sortSubmissions(this.getSubmissions.filter(sub => sub.status == this.categoryFilter).filter(item => item.title.toLowerCase().includes(this.searchString.toLowerCase())))
      }
    },
    getSubmissions(){
      return this.$store.getters.getSubmissions
    },
    getStatusOptions(){
      return this.$store.getters.getStatusOptions
    }
  }
}
</script>
<style scoped>
.submissions:nth-child(odd){
  background: #CCC;
}
</style>
